import React from 'react';
import DatoAsset from '../asset';
const MediaItem = ({ item, alt, className, style, objectFit, objectPosition, autoPlay, muted, isStatic, videoThumbnail, onPlayStateChange, }) => {
    const media = (Array.isArray(item) ? item[0] : item) || null;
    if (!media)
        return null;
    return (React.createElement(DatoAsset, { alt: alt, objectFit: objectFit, objectPosition: objectPosition, className: className, style: style, asset: media.image || media.video || media.externalVideo, autoPlay: autoPlay || media.isInline, muted: muted || media.isInline, thumbnail: media.thumbnail, videoThumbnail: videoThumbnail, isStatic: isStatic, onPlayStateChange: onPlayStateChange }));
};
export default MediaItem;
//# sourceMappingURL=index.js.map